module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "categoryDetails"
  }, [(_vm.category.children) ? _c('i', {
    staticClass: "material-icons action-icon",
    on: {
      "click": function($event) {
        return _vm.toggleSubcategoryVisibility(!_vm.category.showChildren)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.category.showChildren ? "keyboard_arrow_down" : "keyboard_arrow_right") + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.directLink) ? _c('router-link', {
    attrs: {
      "to": '/category/' + _vm.category.id
    }
  }, [_vm._v("\n    " + _vm._s(_vm.category.name) + "\n  ")]) : _c('a', [_vm._v("\n    " + _vm._s(_vm.category.name) + "\n  ")]), _vm._v(" "), (_vm.showStats && !_vm.isMobile()) ? [_c('br'), _vm._v(" "), (_vm.showEditTrigger) ? _c('edit-category-trigger', {
    staticClass: "editIcon",
    attrs: {
      "categoryId": _vm.category.id
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "categoryStats"
  }, [_vm._v("\n      " + _vm._s(_vm.completed) + "\n      /\n      " + _vm._s(_vm.quota) + "\n    ")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-492bb009!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/CategoryDetailsBlock.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-492bb009!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/CategoryDetailsBlock.vue
// module chunks = 0